const zyqy: string[] = ['124fc139-cdf4-4137-b9bb-f6d62702113f', '1e6df74d-d3a6-4373-9d4b-e90f87a3a1f2', 'a0876f18-793e-4d50-8682-07005b3189f8', 'b1de59e7-6e63-47c3-9fc9-d97cfd1281b8'];
const other: string[] = ['da0848aa-3dac-4b1e-87fe-241e7229b912', 'a484d916-9597-46ac-908f-225b7f7da5e7',"827ba2d4-35b6-4bcc-a6af-26cdb577dbaa"];

// 获取登录用户的客户区域类型
export const getUserAreaType = () => {
    var userType=localStorage.getItem('userType')||'other';
    return userType;
};

// 获取登录用户的所属公司信息
export const getUserBUName = () => {
    const user = JSON.parse(localStorage.logonUser);
    if (user && user.BUName) return user.BUName;

    return '';
};
